import React, { } from 'react';
import Calculator from '../Calculator/Calculator';
import { IMainScreenState } from "../../types/IMainScreenState";
import PromoCalculator from '../PromoCalculator/PromoCalculator';
import { useHolidaysTheme } from '../../themes/useTheme';
import { useTimer } from '../../themes/useTimer';
import BottomMainBlock from '../BottomMainBlock/BottomMainBlock';
const birthdayIcon = "images/BirthdayIcon.png";
const giftBox = "images/GiftBox.png";

interface IProps {
  promoCalculator?: boolean;
  data: IMainScreenState;
  onBuyClick: () => void;
  onDataChange: (newState: IMainScreenState) => void;
}

const UpperMainBlock: React.FC<IProps> = ({ data, onBuyClick, onDataChange, promoCalculator }) => {
  const isMobile = window.screen.availWidth < 801
  console.log('isMobile', isMobile)
  const { currentDayNumber, daysLeft, themeText, styles, isHoliday, isPink, isBirthday, isBlackFriday, nextTimeout } = useHolidaysTheme()
  // console.log('isHoliday', isHoliday)
  // useTimer(isHoliday, nextTimeout)
  // console.log('nextTimeout', nextTimeout)
  const createMarkup = (text: string, margin?: number) => {
    if (!text) return ''
    return text.split('\n').map((str, key) => <p key={key} style={{ margin: margin || 0 }}>{str}</p>)
  }

  return (
    <div className={styles.UpperMainRoot}>
      <div className={styles.ProstoAppIcon}></div>
      <div className={styles.BackgroundImageContainer + ' ' + styles.hideOnMobile}>
        <div className={styles.BackgroundImage} />
      </div>
      <div className={styles.MainBlock}>
        <div className={styles.LeftTextContainer} />
        <div className={styles.MainContainer}>
          {promoCalculator
            ? <PromoCalculator data={data} onClick={onBuyClick} onDataChange={onDataChange} promoCalculator={promoCalculator} />
            : <Calculator
              title={themeText.calcTitle}
              subtitle={themeText.calcSubtitle}
              data={data}
              onClick={onBuyClick}
              onDataChange={onDataChange}
            />}
        </div>
        <div className={styles.TextContainer + ' ' + styles.hideOnMobile}>
          <a className={styles.HowItWorks} href="#advices">Как это работает?</a>
          <div className={styles.MainTitle}>{createMarkup(themeText.title, 15)}</div>
          <div className={styles.MainSubtitle || styles.AdditionalText}>{createMarkup(themeText.subtitle, 15)}</div>
          <div className={styles.AdditionalText}>{createMarkup(themeText.subtitleExtra, 15)}</div>
        </div>
      </div>
      <BottomMainBlock />
      <div className={styles.hideOnDesktop} style={{ paddingBottom: 50 }}>
        <div className={styles.BackgroundImageContainer}>
          <div className={styles.BackgroundImage} />
        </div>
        <div className={styles.MainTitle}>{createMarkup(themeText.title, 15)}</div>
        <div className={styles.MainSubtitle || styles.AdditionalText}>{createMarkup(themeText.subtitle, 15)}</div>
        <div className={styles.AdditionalText}>{createMarkup(themeText.subtitleExtra, 15)}</div>
      </div>
    </div>
  );
}

export default UpperMainBlock;
